import axios from "axios";

const api = axios.create({
  baseURL: "/api/shipping",
});

export const getShippingDates = (canShipFromFactory) => {
  return api
    .get(`/date/${canShipFromFactory}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((r) => {
      return r.data;
    })
    .catch((error) => {
      let message = "";
      if (error.response) {
        message = `${error.response.status} ${
          error.response.statusText
        }\n${JSON.stringify(error.response.data)}`;
        // Request made and server responded
        console.log(error.response);
      } else if (error.request) {
        message = "no response";
        console.log(error.request);
      } else {
        message = error.message;
        console.log("Error", error.message);
      }
      throw new Error(message);
    });
};

export const getShippingDatesForVlad = (canShipFromFactory, canShipByVlad) => {
  return api
    .get(`/date/${canShipFromFactory}/${canShipByVlad}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((r) => {
      return r.data;
    })
    .catch((error) => {
      let message = "";
      if (error.response) {
        message = `${error.response.status} ${
          error.response.statusText
        }\n${JSON.stringify(error.response.data)}`;
        // Request made and server responded
        console.log(error.response);
      } else if (error.request) {
        message = "no response";
        console.log(error.request);
      } else {
        message = error.message;
        console.log("Error", error.message);
      }
      throw new Error(message);
    });
};

const apis = {
  getShippingDates,
  getShippingDatesForVlad,
};

export default apis;
